import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { clearLocalStorage, decryptToObject, encryptObject } from 'src/environments/environment';
import { TokenAuth } from 'src/dto/users/users-dto';

@Component({
  selector: 'app-sso-callback',
  templateUrl: './ssocallback.component.html',
})
export class SSOCallbackComponent implements OnInit {
  ssoData: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      const dataParam: TokenAuth = JSON.parse(params['data']);
      if (dataParam) {
        sessionStorage.clear();
        clearLocalStorage();
        dataParam.roles = dataParam.roles.map(role => decryptToObject(role));
        localStorage.setItem('CurrentUser', encryptObject(dataParam));

        this.redirectUser(dataParam);

      }
    });
  }

  private redirectUser(user: any): void {
    switch (user.roles[0]) {
      case 'SUPER_ADMIN':
      case 'ADMIN':
      case 'PIM':
        this.router.navigate(['/pim']);
        break;
      case 'DAM':
        this.router.navigate(['/dam']);
        break;
      case 'CATALOG':
        this.router.navigate(['/catalogues']);
        break;
      case 'MEDIA_MANAGER':
        this.router.navigate(['/dam']);
        break;
      case 'GLRY_VIEW':
        this.router.navigate(['/dam/media-library']);
        break;
      default:
        console.error('Ruolo non riconosciuto');
        this.router.navigate(['/login']);
        break;
    }
  }
}
